import React from "react";
import PropTypes from "prop-types";
import {optionItemFinder, cutRow} from "../../helpers/OptionHelper";

function OptionItem({name, value, valueOther, options}) {
    if (!value) {
        return null;
    }

    const optionItem = optionItemFinder(value, options);
    const optionLabel = optionItem ? optionItem.label : '';

    return <li>
        <div className="sidebar-list-left">{name}</div>
        <div className="sidebar-list-right">{optionLabel}{value === 'Other' ?
            <span style={{maxWidth: '100%', wordBreak: 'break-word'}}> / {valueOther ? cutRow(valueOther, 60) : ''}</span> : ''}</div>
    </li>
}

OptionItem.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    options: PropTypes.array.isRequired,
};

export default OptionItem